
document.addEventListener('DOMContentLoaded', function() {
 
  var acc = document.getElementsByClassName("accordionHeader"); 
  var i; 
  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
  
      /* custom fix to close opened accordions on product page*/ 
      document.querySelectorAll('.accordionHeader').forEach((details)=>{
        if(details != this)
        details.classList.remove("active");        
      });
      document.querySelectorAll('.accordionPanel').forEach((summary)=>{
        if(summary != this.nextElementSibling)
        summary.style.maxHeight = null;
      }); 
      /* fix end here */
      
  
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      } 
    });
  }



  var acc = document.getElementsByClassName("accordionHeader2");
  var i; 
  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
  
      /* custom fix to close opened accordions on product page*/ 
      document.querySelectorAll('.accordionHeader2').forEach((details)=>{
        if(details != this)
        details.classList.remove("active");        
      });
      document.querySelectorAll('.accordionPanel2').forEach((summary)=>{
        if(summary != this.nextElementSibling)
        summary.style.maxHeight = null;
      }); 
      /* fix end here */
      
    
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      } 

      var itemthis =this;
  
      /** 🔄 Refresh parent height **/
      var parent = itemthis.closest(".accordionPanel"); // <-- parent container
      if (parent) {
        // Force reflow to allow transition
        parent.style.maxHeight = parent.scrollHeight + "px"; 
      }  

    });
  }



});



function accordionInitForComp(item){
    var elementItem = document.querySelector(item);
  
    /* custom fix to close opened accordions on product page*/ 
    document.querySelectorAll('.accordionHeader').forEach((details)=>{
      if(details != elementItem)
      details.classList.remove("active");        
    });
    document.querySelectorAll('.accordionPanel').forEach((summary)=>{
      if(summary != elementItem.nextElementSibling)
      summary.style.maxHeight = null;
    }); 
    /* fix end here */
    
 
    elementItem.classList.toggle("active");
    var panel = elementItem.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    } 
}






var accFooter = document.getElementsByClassName("accordionFooter");
var i; 
for (i = 0; i < accFooter.length; i++) {
  accFooter[i].addEventListener("click", function() {

    if(window.innerWidth>749)return;
 
    /* custom fix to close opened accordions on product page*/ 
    document.querySelectorAll('.accordionFooter').forEach((details)=>{
      if(details != this)
      details.classList.remove("active");        
    });
    document.querySelectorAll('.accordionPanelFooter').forEach((summary)=>{
      if(summary != this.nextElementSibling)
      summary.style.maxHeight = null;
    }); 
    /* fix end here */
    
 
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    } 
  });
}


// assigning fixed heights to enable animations properly.
  document.querySelectorAll('.product__info-container .accordionHeader').forEach(header => {
    const panel = header.nextElementSibling; // .accordionPanel
    if (!panel) return;

    if (header.classList.contains('active')) {
      // set to scrollHeight for smooth animation
      panel.style.maxHeight = panel.scrollHeight + "px";
    }  
  });







 

/* Fit-to-parent for elements with .full-width-heading */  
(function () {
  if (window.__FFH__) return; window.__FFH__ = true;

  const SELECTOR = '.full-width-heading';
  if(document.querySelectorAll(SELECTOR).length==0)return;

  const debounce = (fn, ms=120)=>{let t;return(...a)=>{clearTimeout(t);t=setTimeout(()=>fn(...a),ms)}};
  const parentMap = new WeakMap();

  const contentBoxWidth = (el) => {
    const cs = getComputedStyle(el);
    return Math.max(0, el.clientWidth - (parseFloat(cs.paddingLeft)||0) - (parseFloat(cs.paddingRight)||0));
  };

  const optsFromDataset = (el) => ({
    min:     el.dataset.fitMin     ? parseFloat(el.dataset.fitMin)     : 24,
    max:     el.dataset.fitMax     ? parseFloat(el.dataset.fitMax)     : 520,
    safety:  el.dataset.fitSafety  ? parseFloat(el.dataset.fitSafety)  : 1,
    epsilon: el.dataset.fitEpsilon ? parseFloat(el.dataset.fitEpsilon) : 1
  });

  function fitOne(el, overrides={}){
    if (!el || !el.parentElement) return;

    const parent = el.parentElement;
    const {min, max, safety, epsilon} = { ...optsFromDataset(el), ...overrides };

    // make measurement reliable
    el.style.setProperty('display','inline-block','important');
    el.style.setProperty('white-space','nowrap','important');

    const avail = Math.floor(contentBoxWidth(parent) * safety) - epsilon;
    if (avail <= 0) return;

    let low = min, high = max;
    for (let i=0;i<22;i++){
      const mid = (low+high)/2;
      el.style.setProperty('font-size', mid+'px', 'important');
      const w = el.getBoundingClientRect().width;
      if (w <= avail) low = mid; else high = mid;
    }
    el.style.setProperty('font-size', Math.max(1, Math.floor(low))+'px', 'important');
    // inside fitOne(el) AFTER the last setProperty('font-size', ...)
    requestAnimationFrame(()=> el.classList.add('ffh-visible'));
    el.dataset.fitApplied = '1';

    // keep updated when the parent resizes
    if ('ResizeObserver' in window && !parentMap.has(parent)){
      const els = new Set([el]);
      const ro  = new ResizeObserver(debounce(()=> els.forEach(e=>fitOne(e)), 60));
      ro.observe(parent);
      parentMap.set(parent, {ro, els});
    } else if (parentMap.has(parent)){
      parentMap.get(parent).els.add(el);
    }
  }

  function scan(){ 
      document.querySelectorAll(SELECTOR).forEach(el => fitOne(el));
  }

  function boot(){
    scan();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(scan);
  }

  // run now (handles modules/async) + on typical lifecycle hooks
  if (document.readyState !== 'loading') boot();
  document.addEventListener('DOMContentLoaded', boot);
  window.addEventListener('load', boot);
  window.addEventListener('resize', debounce(boot,120));
  window.addEventListener('orientationchange', boot);
  window.addEventListener('pageshow', e => { if (e.persisted) boot(); });

  // catch AJAX / theme-editor injections
  const mo = new MutationObserver(debounce(muts=>{
    for (const m of muts){
      for (const n of m.addedNodes){
        if (n.nodeType === 1){ scan(n); }
      }
    }
  }, 80));
  mo.observe(document.documentElement, {childList:true, subtree:true});

  // common SPA events (if your theme uses them)
  ['swup:contentReplaced','barba:after','page:loaded']
    .forEach(evt => window.addEventListener(evt, boot, {passive:true}));
})();
